import { Button, Card, CardActions, CardContent, CardHeader, Collapse, List, ListItem, ListItemIcon, ListItemText, Theme, useTheme } from "@mui/material";
import { ExpandMore, Square } from "@mui/icons-material";
import { isMobile, isTablet } from "react-device-detect";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { getObjectTypeName } from "../../common/utilities/GetObjectTypeName";
import { useMemo, useState } from "react";

import { useTranslation } from "react-i18next";
import ActionMenu from "../action-menu/ActionMenu";
import { ScheduleActionItem, ScheduleActions } from "./AlarmScheduleCardUtils";
import { ScheduleFormType } from "../alarm-scheme-editor/tier-editor/TierEditorUtils";
import { SxProps } from "@mui/system";


export type AlarmScheduleCardProps = {
    item: ScheduleFormType,
    onAction?: (action: ScheduleActions, item: ScheduleFormType) => void,
    dense?: boolean,
    sx?: SxProps<Theme>
};

export function AlarmScheduleCard({
    item,
    onAction,
    dense,
    sx
}: AlarmScheduleCardProps) {

    const [expanded, setExpanded] = useState(false);
    const isPhone = isMobile && !isTablet;
    const theme = useTheme();
    const { t }= useTranslation();

    const actionItems: ScheduleActionItem[] = useMemo(() => {

        let actions: ScheduleActionItem[] = [{

            label: t('actions.editScheduledNotification'),
            action: ScheduleActions.Edit,
            order: 0,
            onClick: () => {
                onAction && onAction(ScheduleActions.Edit, item);
            },
        },
        {

            label: t('actions.deleteScheduleNotification'),
            action: ScheduleActions.Delete,
            order: 0,
            onClick: () => {
                onAction && onAction(ScheduleActions.Delete, item);
            },
        }];
        
        
        return actions;

    }, [
        item,
        t,
        onAction
    ]);

    function toggleExpanded() {
        setExpanded(!expanded);
    }

    return (
        <Card variant="outlined" 
            sx={{
            
                backgroundColor: "custom.background.cardContainer",
                marginLeft: isPhone || dense ? 1 : 6,
                marginRight: 1,
                padding: 1,
                marginBottom: 1,
                ...sx
            }}>
            <CardHeader
                sx={{
                    padding: 1,
                    color: theme.palette.grey[600]
                }}
                title={item.name}
                //avatar={getAvatar()}
                //subheader={item.description}
                action={<ActionMenu actionItems={actionItems} />}
                slotProps={{
                    title: {
                        sx: {
                            fontSize: '1rem'
                        }
                    },

                    subheader: {
                        sx: {
                            fontSize: '.9rem'
                        }
                    }
                }}>
            </CardHeader>
            <CardActions sx={{ paddingTop: 0, paddingBottom: 0 }}>
                <Button
                    size="small"
                    sx={{
                        //color: "text.primary"
                        color: theme.palette.grey[600]
                    }}
                    variant="text"
                    onClick={() => toggleExpanded()}
                    style={{ marginLeft: "auto" }}
                    endIcon={<ExpandMore sx={{
                        transform: !expanded ? "rotate(0deg)" : "rotate(180deg)",
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shortest,
                        })
                    }} />}
                >
                    {`${getObjectTypeName(eLynxObjectTypeEnum.NotificationList, true)} [${item.notificationLists.length}]`}
                </Button> 
            </CardActions>
            <Collapse in={expanded} timeout="auto">

                <CardContent sx={{
                    padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
                }}>

                    <List sx={{
                        paddingTop: 0,
                        overflowX: "hidden",
                        overflowY: "auto",
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 auto'
                    }}>
                        {item.notificationLists.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))?.map((o, index) =>

                            <ListItem key={index} 
                                disablePadding >
                                <ListItemIcon sx={{fontSize: ".6rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                                    <Square fontSize="inherit"/>
                                </ListItemIcon>
                                <ListItemText primary={o.name} 
                                    slotProps={{
                                        primary: {
                                            sx:{
                                                fontSize: '.9rem'
                                            }
                                        }
                                    }} />
                            
                            </ListItem>
                        )}
                    </List>
               </CardContent>
            </Collapse>
        </Card>
    );
}
